export function initProductVariant() {

  console.log("initProductVariant ... ")

  const gallery = document.querySelector('[data-variant-gallery]');
  const panel = document.querySelector('.product-detail__selection-panel');
  if (!gallery || !panel) return;

  function applyShipping(value) {
    panel.dataset.shipping = value === 'multi_address' ? 'multi_address' : 'single_address';
  }

  /* The message is duplicated below the Shipping options and below the Select
     button, so match on the data attribute to switch every copy at once. */
  function showDeliveryMessage(type) {

    document.querySelectorAll('.product-detail__delivery-message')
        .forEach(el => el.classList.remove('active'));

    let messageType = "default";

    switch(type) {
      case 'single_address':
        messageType = "single_address";
        break;
      case 'multi_address' :
        messageType = "multi_address";
        break;
    }
    console.log("message type is : " + messageType)
    document.querySelectorAll(`[data-delivery-message="${messageType}"]`)
        .forEach(el => el.classList.add('active'));
  }

  const defaultShipping = panel.querySelector('input[name="shipping"]:checked');
  console.log("defaultShipping: " + defaultShipping?.value);
  const initialShipping = defaultShipping?.value || 'single_address';
  applyShipping(initialShipping);
  showDeliveryMessage(initialShipping);

  panel.addEventListener('change', e => {
    if (!e.target.matches('input[type="radio"]')) return;
    if (e.target.name === 'shipping') {
      applyShipping(e.target.value);
      showDeliveryMessage(e.target.value)
    }
  });
}
